var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('small',{staticClass:"font-weight-bold text-muted text-capitalize"},[_vm._v(" "+_vm._s(_vm.titleCapitalized)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }